import { useState } from "react";
import { Link } from "react-router-dom";
import { SUGERIDOS, fmtDate } from "@/lib/api";

const EST = [
  { k: "APROBADO", label: "Aprobado", bar: "bg-emerald-500", txt: "text-emerald-700" },
  { k: "MÁS ADELANTE", label: "Más adelante", bar: "bg-amber-400", txt: "text-amber-700" },
  { k: "NO APROBADO", label: "No aprobado", bar: "bg-rose-500", txt: "text-rose-700" },
  { k: "SIN CONTESTAR", label: "Sin contestar", bar: "bg-slate-300", txt: "text-slate-500" },
];
const lbl = (id) => SUGERIDOS.find((s) => s.id === id)?.label || id;
const n = (r, k) => (r.estados[k] || []).length;
const tot = (r) => EST.reduce((s, e) => s + n(r, e.k), 0);

const Fila = ({ r, i, sel, onSel }) => {
  const t = tot(r);
  return (
    <div className="grid grid-cols-[minmax(0,14rem)_1fr_auto] items-center gap-3 text-xs" data-testid={`resp-tto-stat-${i}`}>
      <span className="truncate text-slate-800" title={lbl(r.tto)}>{lbl(r.tto)}</span>
      <span className="flex h-3 rounded-full bg-slate-100 overflow-hidden">
        {EST.map((e) => n(r, e.k) > 0 && <span key={e.k} className={e.bar} style={{ width: `${(n(r, e.k) * 100) / t}%` }} title={`${e.label}: ${n(r, e.k)}`} />)}
      </span>
      <span className="flex gap-2 whitespace-nowrap">
        {EST.map((e) => (
          <button key={e.k} type="button" disabled={!n(r, e.k)} onClick={() => onSel(sel === `${r.tto}|${e.k}` ? null : `${r.tto}|${e.k}`)} data-testid={`resp-tto-stat-${i}-${e.k.replace(/\s|Á/g, "_").toLowerCase()}`}
            className={`font-[JetBrains_Mono] font-semibold ${e.txt} disabled:opacity-30 ${sel === `${r.tto}|${e.k}` ? "underline" : "hover:underline"}`}>
            {Math.round((n(r, e.k) * 100) / t)}%<span className="font-normal text-slate-400"> ({n(r, e.k)})</span>
          </button>
        ))}
      </span>
    </div>
  );
};

export const RespuestasTto = ({ rows }) => {
  const [sel, setSel] = useState(null);
  const orden = [...rows].sort((a, b) => n(b, "APROBADO") / tot(b) - n(a, "APROBADO") / tot(a) || tot(b) - tot(a));
  const [tto, est] = sel ? sel.split("|") : [];
  const items = sel ? rows.find((r) => r.tto === tto)?.estados[est] || [] : [];
  return (
    <div className="mb-6 fade-up" data-testid="stat-respuestas-tto">
      <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-600 mb-2">Qué tratamientos aprueban las familias</h3>
      <div className="bg-white border border-slate-200 rounded-lg p-4 space-y-2 lg:w-2/3">
        <div className="flex flex-wrap gap-3 text-[11px] text-slate-500 mb-1">{EST.map((e) => <span key={e.k} className="flex items-center gap-1"><span className={`h-2 w-2 rounded-full ${e.bar}`} />{e.label}</span>)}</div>
        {orden.map((r, i) => <Fila key={r.tto} r={r} i={i} sel={sel} onSel={setSel} />)}
        {sel && (
          <div className="mt-3 border-t border-slate-100 pt-2" data-testid="resp-tto-stat-lista">
            <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 mb-1">{lbl(tto)} · {EST.find((e) => e.k === est)?.label}</p>
            {items.map((it, i) => (
              <Link key={i} to={it.link} className="flex gap-3 py-1 text-sm hover:bg-slate-50 rounded px-1" data-testid={`resp-tto-stat-item-${i}`}>
                <span className="flex-1 text-slate-800">{it.nombre}</span><span className="text-xs text-slate-500">{it.centro}</span><span className="text-xs text-slate-400">{fmtDate(it.fecha)}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
      <p className="mt-1 text-[11px] text-slate-400">Pacientes con examen en estas fechas que tienen la respuesta desglosada por tratamiento. Pulsa un porcentaje para ver quiénes son.</p>
    </div>
  );
};
